import { ClientPortalRoute } from "../../../features/clientPortal/ClientPortalTab";
import { OrganizationBilling } from "../../../features/contacts/pages/organization/pages/organization-billing/OrganizationBilling";
import { OrganizationEmails } from "../../../features/contacts/pages/organization/pages/organization-emails/OrganizationEmails";
import { OrganizationNotes } from "../../../features/contacts/pages/organization/pages/organization-notes/OrganizationNotes";
import { OrganizationProfile } from "../../../features/contacts/pages/organization/pages/organization-profile/OrganizationProfile";
import { OrganizationTime } from "../../../features/contacts/pages/organization/pages/organization-time/OrganizationTime";
import { OrganizationWorks } from "../../../features/contacts/pages/organization/pages/organization-works/OrganizationWorks";
import { ClientFilesRoute } from "../../../features/files/ClientFilesRoute";
import { ContactPagesEnum } from "./contact-routes";
import { PagesEnum } from "./types";

export enum OrganizationPagesEnum {
  Profile = "profile",
  Works = "work",
  Time = "time",
  Notes = "notes",
  Files = "files",
  Billing = "billing",
  Emails = "emails",
  Portal = "portal",
}

export const OrganizationPages = {
  path: PagesEnum.Organization,
  label: "Organization",
  component: null,
  children: {
    profile: {
      path: OrganizationPagesEnum.Profile,
      label: "Profile",
      component: OrganizationProfile,
    },
    works: {
      path: OrganizationPagesEnum.Works,
      label: "Work",
      component: OrganizationWorks,
    },
    time: {
      path: OrganizationPagesEnum.Time,
      label: "Time",
      component: OrganizationTime,
    },
    files: {
      path: OrganizationPagesEnum.Files,
      label: "Files",
      component: ClientFilesRoute,
    },
    notes: {
      path: OrganizationPagesEnum.Notes,
      label: "Notes",
      component: OrganizationNotes,
    },
    billing: {
      path: OrganizationPagesEnum.Billing,
      label: "Billing",
      component: OrganizationBilling,
    },
    emails: {
      path: ContactPagesEnum.Emails,
      label: "Email",
      component: OrganizationEmails,
    },
    // Roadmap 1880: the Client portal has its own tab (was a profile widget).
    portal: {
      path: OrganizationPagesEnum.Portal,
      label: "Client portal",
      component: ClientPortalRoute,
    },
  },
};
